﻿import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { catchError, tap } from 'rxjs/operators';
import { User } from '../models/user';
import { Role } from '../models/role';
import { AccessLevels } from '../models/access_levels';
import { Router } from '@angular/router';

const TOKEN_KEY = 'access_token';
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'x-access-token': ''
    })
};
const TOKEN = 'token';


@Injectable({ providedIn: 'root' })
export class AuthenticationService {

    url = environment.url;
    authenticationState = new BehaviorSubject(false);
    public authToken: any;

    constructor(public http: HttpClient, public jwtHelper: JwtHelperService, private router: Router) { }

    login(username: string, password: string) {
        var credentials = {
            "email": username,
            "password": password,
        }
        return this.http.post(`${this.url}` + '/auth/authenticate', credentials).pipe(tap((res) => {
            if (res && res['status']) {
                this.saveToken(res['result']['token'])
                this.authenticationState.next(true);
                localStorage.setItem('currentUserName', res['result']['name']);
            }
            return res;
        }),
        );
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUserName');
        localStorage.removeItem('assignedSearchCriteria');
        localStorage.removeItem('unassignedSearchCriteria');
        localStorage.removeItem('reservationSearchCriteria');
        localStorage.removeItem(TOKEN);
    }


    forgotPassword(email) {
        let data = {
            "email": email,
            isAdmin: true
        }
        return this.http.post(`${this.url}` + '/email/sendEmail', data).pipe(tap(res => console.log(res)),
            catchError(err => throwError(new Error('Issue in sending email'))),
        );
    }

    changePassword(oldpassword, newpassword) {
        let data = {
            "oldPassword": oldpassword,
            "newPassword": newpassword
        }
        return this.http.post(`${this.url}` + '/employee/changePassword', data).pipe(tap(res => console.log(res)),
            catchError(err => throwError(new Error('Issue in updating password'))),
        );
    }

    public saveToken(token: string) {
        localStorage.removeItem(TOKEN);
        localStorage.setItem(TOKEN, token);
    }

    public getToken(): string {
        return localStorage.getItem(TOKEN);
    }


    public isAuthenticated(): boolean {
        const token = localStorage.getItem(TOKEN);
        if (token != null) {
            if(this.jwtHelper.isTokenExpired(token)){
                localStorage.clear()
            }
            //console.log(this.jwtHelper.isTokenExpired(token));
            return !this.jwtHelper.isTokenExpired(token);
        } else {
            localStorage.clear();
            return false;
        }
    }


    decodeJwtToken() {
        const token = localStorage.getItem(TOKEN);
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        // console.log(jsonPayload)
        return JSON.parse(jsonPayload);
    };


    public getAccessLevel() {
        return this.decodeJwtToken().access_level;
    }


    public getCurrentUserId() {
        return this.decodeJwtToken().id;
    }

    public isStationAdmin(): boolean {
        return this.getAccessLevel() == AccessLevels.stationManager ? true : false;
    }
}